
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 150 150"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M65.16.36h41.43a5.13 5.13 0 014.57 7.44L89 51.56A5.13 5.13 0 0093.58 59h16.64a5.12 5.12 0 014.14 8.14l-58.81 80.72c-3.45 4.75-10.88.89-9-4.67L63.72 93a5.13 5.13 0 00-4.85-6.78h-19A5.12 5.12 0 0135 79.43L60.3 3.86a5.13 5.13 0 014.86-3.5z","fill":"#fadf00"}}),_c('path',{attrs:{"d":"M110.22 59h-5.62a5.12 5.12 0 014.14 8.14l-58.8 80.72a5.56 5.56 0 01-1.3 1.27 5 5 0 006.91-1.27l58.81-80.72a5.12 5.12 0 00-4.14-8.14zM105.55 7.8L83.4 51.56A5.12 5.12 0 0088 59h5.61A5.13 5.13 0 0189 51.56L111.16 7.8a5.13 5.13 0 00-4.57-7.44H101a5.13 5.13 0 014.55 7.44z","fill":"#fbac18"}})])
          )
        }
      }
    